module.exports = __webpack_public_path__ + "media/images/favicon-42883971783943b903caea7ba13f1a00.ico";